export default __webpack_public_path__ + "567558a69b636ebc5d857683eae1f75f.svg";